/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import Screen from '../Screen';
import Section from '../../Section/Section';
import Comment from '../../Comment/Comment';
import Textbox from '../../Textbox/Textbox';
import Button from '../../Button/Button';
import Snackbar from '../../Snackbar/Snackbar';
import Folderselector from '../../Folderselector/Folderselector';
import Service from '../../Util/Service';
import './Settings.css';

/**
 * Represents the settings screen.
 */

export default class Settings extends Screen {

    /**
     * Default state.
     */

    state = {
        homedirectory:      null
    }

    /**
     * Saves the settings of the user.
     */

    _save = () => {

        // Validating

        if (!this.name.validate()) {
            return;
        }

        // Showing progress indicator

        this.props.onLoading(true);

        // Saving the settings

        Service.saveSettings(this.props.context.user.uid, { 
            name:           this.name.getValue(),
            homedirectory:  this.state.homedirectory
        }).then(() => {

            // Showing confirm message

            this.snackbar.show(this.props.context.locale.settings.save_success);

            // Hiding progress indicator

            this.props.onLoading(false);
        }).catch((error) => {

            // Showing error

            this.snackbar.show(this.props.context.locale.error.database, true);

            // Hiding progress indicator

            this.props.onLoading(false);
        });
    }

    /**
     * Event that fires when a folder selected for home directory.
     * 
     * @param   {Object}    folder  selected folder
     */

    _onHomeDirectorySelected = (folder) => {
        this.setState({ homedirectory: folder.path });
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(this.props.context.locale.settings.title);

        // Showing progress indicator

        this.props.onLoading(true);

        // Loading user settings

        Service.loadUser(this.props.context.user.uid).then((settings) => {

            // Refreshing the settings

            this.name.setValue(settings.name);
            this.setState({ homedirectory: settings.homedirectory });

            // Refreshing the folder tree

            this.folderselector.load().then(() => {

                // Selecting the loaded home directory

                this.folderselector.select(settings.homedirectory);

                // Hiding progress indicator

                this.props.onLoading(false);    
            });
        }).catch(() => {

            // Showing error

            this.snackbar.show(this.props.context.locale.error.database, true);

            // Hiding progress indicator

            this.props.onLoading(false);
        });
    }

    /** 
     * Settings screen renderer.
     */

    render() {
        return (
            <div className="settings">

                {/* Settings container */}

                <div className="settings-container">

                    {/* Username */}

                    <Section label={this.props.context.locale.settings.username.title} />
                    <Comment bottomgap={8} text={this.props.context.locale.settings.username.comment} />
                    <Textbox ref={c => {this.name = c;}} tooltip={this.props.context.locale.settings.username.tooltip} placeholder={this.props.context.locale.settings.username.placeholder} maxlength={100} width={this.props.context.environment.browser.info.mobile ? (this.props.context.environment.screen.width - 60) : 320} tocapitalize isrequired validateonblur />

                    {/* Home directory */}

                    <Section label={this.props.context.locale.settings.homedirectory.title} />
                    <Comment bottomgap={8} text={this.props.context.locale.settings.homedirectory.comment} />
                    <Folderselector ref={c => {this.folderselector = c;}} context={this.props.context} onSelect={this._onHomeDirectorySelected} onLoading={this.props.onLoading} />

                    {/* Save button */}

                    <div className="horizontal">
                        <div className="flex"></div>
                        <Button label={this.props.context.locale.settings.save.label} tooltip={this.props.context.locale.settings.save.tooltip} topgap={16} onTouch={this._save} />
                    </div>
                </div>

                {/* Snackbar */}

                <Snackbar ref={c => {this.snackbar = c;}} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Settings/Settings.js